import React from 'react';

const StudentPhotoModal = ({ isOpen, onClose, photoUrl }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded-lg shadow-lg max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-black"
        >
          ✕
        </button>
        <img src={`${process.env.REACT_APP_API_URL}/${photoUrl}`} alt="Student" className="w-full h-auto rounded" />
      </div>
    </div>
  );
};

export default StudentPhotoModal;
